import React from "react";
import PaymentRoutes from "../../payment";
import AuthRoutes from "../../auth";
import { Route } from "react-router";
import { Redirect } from "react-router";
import EmailPreferences from "../../pages/EmailPreferences";
import { Routes } from "../../../constants/routes";

export default function Public({ prefix }: { prefix: string }) {
  return (
    <>
      <Route path={`${prefix}`} exact>
        <Redirect to="/0" />
      </Route>

      <AuthRoutes path={prefix} />

      <PaymentRoutes path={prefix} />

      <Route
        path={`${prefix}${Routes.EMAIL_PREFERENCES}`}
        exact
        component={EmailPreferences}
      ></Route>
    </>
  );
}
